var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.267242 0.235624C0.606957 -0.0938109 1.16562 -0.0702758 1.50532 0.259155L6.99253 5.79214L12.504 0.259155C12.8437 -0.07028 13.4024 -0.0938011 13.7421 0.235624C14.0818 0.56506 14.0818 1.08328 13.7664 1.43624L8.20634 6.99276L13.7664 12.5728C14.0818 12.9023 14.0818 13.444 13.7421 13.7734C13.4024 14.0793 12.8437 14.0793 12.504 13.7499L6.99253 8.21691L1.50532 13.7499C1.1656 14.0793 0.606943 14.0793 0.267242 13.7734C-0.072473 13.444 -0.0967281 12.9022 0.242977 12.5728L5.803 6.99276L0.242977 1.43624C-0.0967382 1.08328 -0.0724687 0.565046 0.267242 0.235624Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.8c10f8ed.svg";
export { ForwardRef as ReactComponent };